// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__E11vE","colBig":"styles_colBig__2nrgJ","colSmall":"styles_colSmall__31oZO","shopifyNameWrapper":"styles_shopifyNameWrapper__W8li3"};